import api from 'common/api';

export const getFilterCargoTraceInformationAPI = (params: any) => api.get('/cargo-information/search', params);

export const getContainerInformationAPI = (params: any) => api.get('/container-infomation/list', params);

export const getCargoUserListAPI = (params: any) => api.get('/cargo-information/user-list', params);

export const DOWNLOAD_CARGO_FILE_API = '/cargo-information/download';

export const DOWNLOAD_CARGO_PDF_API = '/cargo-information/download-pdf';
